module.exports = __webpack_public_path__ + "img/menu-wrong.a692a423.jpg";